import React, { Fragment, useCallback, useMemo, useState } from 'react';
import { injectIntl } from 'react-intl';

import { SettingField } from 'components/_/form/setting-field/SettingField';
import { CustomUserProfileFieldDefinition } from 'models/user/userProfileField/definition/CustomUserProfileFieldDefinition';

function RenderField({ field, intl, editable, onFieldChange, ...props }) {
	const [error, setError] = useState(null);
	const userProfileService = props['services.userProfileService'];
	const fieldProps = useMemo(() => {
		const settingFieldProps = {
			label: null,
			name: null,
			defaultValue: field.value(),
			editable: editable && field.definition().userEditable(),
			type: field.definition().valueType() === 'text' ? 'textarea' : 'input',
			valueType: field.definition().valueType(),
		};

		if (field.definition() instanceof CustomUserProfileFieldDefinition) {
			settingFieldProps.label = field.definition().name();
			settingFieldProps.name = field.definition().name();
		} else {
			settingFieldProps.label = intl.formatMessage({
				id: `user-profile.field.mapped.${field.definition().mappedProfileField()}`,
			});
			settingFieldProps.name = field.definition().mappedProfileField();
		}

		return settingFieldProps;
	}, [field, editable]);
	const onSave = useCallback(
		async value => {
			setError(null);

			if (field.definition() instanceof CustomUserProfileFieldDefinition) {
				await userProfileService
					.editUserProfileField({ field, value })
					.catch(e => {
						if (
							typeof e?.error === 'object' &&
							e.error.messageId &&
							e.error.messageId === 'invalid-email'
						) {
							setError(e.error.messageId);
						} else {
							throw e;
						}
					})
					.then(() => onFieldChange(field.definition().name(), value));
			} else {
				await userProfileService
					.editUserProfileField({ field, value })
					.catch(e => {
						if (
							typeof e?.error === 'object' &&
							e.error.messageId &&
							e.error.messageId === 'invalid-email'
						) {
							setError(e.error.messageId);
						} else {
							throw e;
						}
					})
					.then(() => onFieldChange(field.definition().mappedProfileField(), value));
			}
		},
		[field]
	);

	return (
		<SettingField {...fieldProps} onSave={onSave} inForm={false} error={error ? { message: error } : undefined} />
	);
}

export default injectIntl(({ fields, ...props }) => (
	<Fragment>
		<hr className="mb-2 mb-sm-3" />
		<div className="p-2 m-0 mr-md-4">
			<div className="row no-gutters">
				{fields.include(['text']).map(field =>
					!field.value() && !(props.editable && field.definition().userEditable()) ? null : (
						<div className="col-24 mb-4" key={field.definition().id()}>
							<RenderField field={field} {...props} />
						</div>
					)
				)}
			</div>
			<div className="row mb-4 pb-2">
				{fields.exclude(['text', 'image']).map(field =>
					!field.value() && !(props.editable && field.definition().userEditable()) ? null : (
						<div className="col-24 col-md-12 mb-2" key={field.definition().id()}>
							<RenderField field={field} {...props} />
						</div>
					)
				)}
			</div>
		</div>
	</Fragment>
));
